import {logger, Util} from 'yougile-util'
import {isSafari} from '@extensions/platform'

const recordingState: {
  recorder: MediaRecorder | undefined
} = {
  recorder: undefined
}

// supported by chrome, firefox, opera
// not supported by safari
const mimeType = 'video/webm; codecs="vp8, opus"'

export class Recorder {
  private static async requestMicrophone(): Promise<MediaStream | undefined> {
    try {
      const mic = await navigator.mediaDevices.getUserMedia({
        video: false,
        audio: true
      })
      return mic
    } catch (_) {
      return undefined
    }
  }
  static async requestPermissions(): Promise<{withSound: boolean}> {
    const screen = await navigator.mediaDevices.getDisplayMedia({
      video: {displaySurface: 'monitor'} as any,
      audio: true
    })
    const mic = await this.requestMicrophone()
    const combined = mic
      ? new MediaStream([...screen.getTracks(), ...mic.getTracks()])
      : screen

    const options: {[key: string]: string} = {}
    if (!isSafari()) {
      options.mimeType = mimeType
    }

    const recorder = new MediaRecorder(combined, options)
    recordingState.recorder = recorder

    screen.addEventListener('inactive', () => {
      logger.log('inactive, stopping recorder')
      if (recorder.state !== 'inactive') {
        recorder.stop()
      }
      for (const track of combined.getTracks()) {
        track.stop()
      }
    })
    return {withSound: !!mic}
  }

  static async start(): Promise<Blob | undefined> {
    const {recorder} = recordingState
    if (!recorder) {
      return undefined
    }
    const chunks: Blob[] = []
    recorder.addEventListener('dataavailable', e => chunks.push(e.data))

    await Util.wait(100)

    return new Promise(ok => {
      recorder.addEventListener('stop', async () => {
        ok(new Blob(chunks, {type: 'video/mp4'}))
      })
      const timeSliceMs = 500
      recorder.start(timeSliceMs)
    })
  }

  static stop(): void {
    const tracks = recordingState.recorder?.stream.getTracks() ?? []
    for (const track of tracks) {
      track.stop()
    }
  }

  static pause(): void {
    recordingState.recorder?.pause()
  }

  static resume(): void {
    recordingState.recorder?.resume()
  }
}
